export function hasOptedInToOneTrust() {
  const activeGroups = (window as OneTrustWindow).OnetrustActiveGroups ?? '';
  return activeGroups.split(',').includes('C0004');
}

export function subscribeToOneTrustConsentChanged(callback: () => void) {
  window.addEventListener(ONE_TRUST_CONSENT_CHANGED_EVENT, callback);

  return () => window.removeEventListener(ONE_TRUST_CONSENT_CHANGED_EVENT, callback);
}

const ONE_TRUST_CONSENT_CHANGED_EVENT = 'order:onetrust-consent-changed';

type OneTrustWindow = Window & { OnetrustActiveGroups?: string };
